import {
  GET_FACILITY_VACCINATION_SUCCESS,
  GET_FACILITY_VACCINATION_FAILURE,
  DELETE_VACCINATION_STATEMENT_SUCCESS,
  DELETE_VACCINATION_STATEMENT_FAILURE,
  DELETE_VACCINATION_STATEMENT_REQUEST,
} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case GET_FACILITY_VACCINATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case GET_FACILITY_VACCINATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    case DELETE_VACCINATION_STATEMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_VACCINATION_STATEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case DELETE_VACCINATION_STATEMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
